import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { FaBars, FaFacebookF, FaInstagram } from "react-icons/fa";
import { BsMinecartLoaded } from "react-icons/bs";
import { FontSize2, FontSize4, NolKoma7to1rem } from '../GlobalStyles';
import { Link, useNavigate } from 'react-router-dom';
import { AiOutlineSearch, AiOutlineUser } from "react-icons/ai";
import { SidebarData } from './Sidebar/SidebarData';

const TopWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 7px calc(3vw);
    @media (min-width: 800px) {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        justify-items: center;
    }
`
const BarIcon = styled(FaBars)`
    font-size: 1.3rem;
    color: black;
    cursor: pointer;
    @media (min-width: 800px) {
        display: none;
    }
`
const CartIcon = styled(BsMinecartLoaded)`
    font-size: 1.3rem;
    color: black;
    @media (min-width: 800px) {
        display: none;
    }
`
const Title = styled(Link)`
    font-size: ${FontSize2};
    text-transform: uppercase;
    letter-spacing: 6px;
    span {
        font-weight: bold;
    }
`
const IconWrap = styled.div`
    display: none;
    svg {
        font-size: ${FontSize4};
    }
    @media (min-width: 800px) {
        display: grid;
        grid-auto-flow: column;
        gap: 1rem;
        justify-self: start;
        & ~ & {
            justify-self: end;
        }
        div {
            display: flex;
            flex-direction: column;
            align-items: center;
            p {
                font-size: 0.8rem;
                margin-top: 0.5rem;
            }
        }
    }
`
const MenuListWrap = styled.div`
    display: none;
    @media (min-width: 800px) {
        display: block;
        /* background-color: blue; */
        padding: 12px 0;
    }
`
const MenuList = styled.div`
    @media (min-width: 800px) {
        /* background-color: #afb2cf; */
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        max-width: 1200px;
        & > p {
            cursor: pointer;
            text-transform: uppercase;
            font-size: ${NolKoma7to1rem};
            font-weight: bold;
            padding: 10px 0;
            position: relative;
            &::after {
                content: '';
                display: block;
                width: 0;
                height: 2px;
                background-color: #000;
                transition: width 500ms ease;
                position: absolute;
                left: 0;
                bottom: -5px;
            }
            &:hover::after {
                width: 100%;
            }
        }
        & > *:not(:last-child) {
            margin-right: 1.1rem;
        }
    }
`
const SubMenuList = styled.div`
    display: none;
    @media (min-width: 800px) {   
        /* background-color: blue; */
        max-width: 800px;
        margin: 0 auto;
        padding: 1rem 2rem;
        display: flex;
        justify-content: space-evenly;
    }
`
const SubListContainer = styled.div`
    
`
const Heading = styled.p`
    font-weight: bold;
    text-transform: uppercase;
    font-size: ${NolKoma7to1rem};
    cursor: pointer;
`
const CucuListContainer = styled.div`
    display: grid;
    gap: 10px;
    margin-top: 1rem;
    p {
        text-transform: uppercase;
        font-size: ${NolKoma7to1rem};
        cursor: pointer;
    }
`
const RelativeParent = styled.div`
    position: relative;
    z-index: 2;
`
const AbsoluteWrap = styled.div`
    background-color: #f6fafa;
    position: absolute;
    width: 100%;
`
const Wrapper = styled.div`
    /* position: sticky;
    top: 10px; */
    background-color: white;
    /* position: fixed;
    top: 0;
    left: 0;
    right: 0; */
`

export default function TopHeader({toggleSidebar}) {
  const [subList, setSubList] = useState(undefined)
  const navigate = useNavigate()
  const refNav = useRef()
  const onMouseOver = (sub) => {
      if (sub) {
          setSubList(sub)
      } else {
          setSubList([])
      }
  }
  const headingOnClick = sub => {
      if (!sub.subSubNav) {
          navigate('/lists')
          setSubList(undefined)
      } else {
          return
      }
  }
  const cucuOnClick = () => {
    navigate('/lists')
    setSubList(undefined)
  }
  const menuOnClick = menu => {
    if (!menu) {
        navigate('/lists')
        setSubList(undefined)
    } else {
        return
    }
  }
  useEffect(() => {
    const eventOnScroll = () => {
        window.addEventListener('scroll', () => {
            if (window.pageYOffset > 30) {
                refNav.current.style.position = 'fixed'
                refNav.current.style.top = '0'
                refNav.current.style.left = '0'
                refNav.current.style.right = '0'
                refNav.current.style.zIndex = '2'
            } else {
                refNav.current.style.position = 'static'
            }
        })
    }
    eventOnScroll()
    return () => window.removeEventListener('scroll', eventOnScroll)
  }, [])
  return (
    <Wrapper ref={refNav}>
        <TopWrapper onMouseOver={() => setSubList(undefined)}>
            <IconWrap>
                <FaFacebookF/>
                <FaInstagram/>
            </IconWrap>
            <BarIcon onClick={toggleSidebar}/>
            <Title to={'/'}>hijabista<span>hub</span></Title>
            <CartIcon/>
            <IconWrap>
                <div>
                    <AiOutlineSearch/>
                    <p>Search</p>
                </div>
                <div>
                    <AiOutlineUser/>
                    <p>Sign In</p>
                </div>
                <div>
                    <BsMinecartLoaded/>
                    <p>Bag</p>
                </div>
            </IconWrap>
        </TopWrapper>
        <MenuListWrap>
            <MenuList>
                {
                    SidebarData.map((menu, idx) => (
                        <p 
                            onMouseOver={() => onMouseOver(menu.subNav ? menu.subNav : null)} key={idx}
                            onClick={() => menuOnClick(menu.subNav ? menu.subNav : undefined)}
                        >
                            {menu.title}
                        </p>
                    ))
                }
            </MenuList>
        </MenuListWrap>
        {
           subList && subList.length > 0 ? (
               <RelativeParent onMouseLeave={() => setSubList(undefined)}>
                <AbsoluteWrap>
                    <SubMenuList>
                        {
                            subList.map((sub, idx) => (
                                    <SubListContainer key={idx}>
                                        <Heading onClick={() => headingOnClick(sub)}>{sub.title}</Heading> 
                                        {
                                            sub.subSubNav ? (
                                                <CucuListContainer>
                                                    {
                                                        sub.subSubNav.map((cucu, cucuIdx) => (
                                                            <p key={cucuIdx} onClick={cucuOnClick}>{cucu.title}</p>
                                                        ))
                                                    }
                                                </CucuListContainer>
                                            ) : null
                                        }   
                                    </SubListContainer>
                                ))
                        }
                    </SubMenuList>
                </AbsoluteWrap>
               </RelativeParent>
           ) : subList ? (
               <RelativeParent onMouseLeave={() => setSubList(undefined)}>
                   <AbsoluteWrap>
                       <SubMenuList>
                           <p style={{ fontSize: '14px', fontWeight: 'bold' }}>NO SUB ITEMS</p>
                       </SubMenuList>
                   </AbsoluteWrap>
               </RelativeParent>
           ) : null
        }
    </Wrapper>
  )
}